"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Stat = void 0;
var _react = _interopRequireDefault(require("react"));
var _Status = require("../Status");
var _SectionHeader = require("../SectionHeader");
var _Stat = require("./Stat.styles");
var _Flag = require("../Flag");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var Stat = function Stat(props) {
  var title = props.title,
    value = props.value,
    style = props.style,
    infoTip = props.infoTip,
    variant = props.variant,
    statusVariant = props.statusVariant,
    testId = props.testId,
    alignRight = props.alignRight,
    titleAlignRight = props.titleAlignRight;
  var classes = (0, _Stat.useStyles)({
    secondary: variant === 'secondary',
    alignRight: alignRight
  });
  switch (variant) {
    case 'secondary':
      return /*#__PURE__*/_react["default"].createElement("div", {
        "data-testid": testId,
        className: classes.root,
        style: style
      }, /*#__PURE__*/_react["default"].createElement("p", {
        className: classes.secondaryTitle
      }, title, " "), /*#__PURE__*/_react["default"].createElement("p", {
        className: classes.value
      }, value));
    case 'status':
      return /*#__PURE__*/_react["default"].createElement("div", {
        "data-testid": testId,
        className: classes.root,
        style: style
      }, /*#__PURE__*/_react["default"].createElement(_SectionHeader.SectionHeader, {
        text: title,
        infoTip: infoTip,
        alignRight: titleAlignRight
      }), /*#__PURE__*/_react["default"].createElement("p", {
        className: classes.value
      }, /*#__PURE__*/_react["default"].createElement(_Status.Status, {
        variant: statusVariant
      }, value)));
    case 'currency':
    case 'country':
      return /*#__PURE__*/_react["default"].createElement("div", {
        "data-testid": testId,
        className: classes.root,
        style: style
      }, /*#__PURE__*/_react["default"].createElement(_SectionHeader.SectionHeader, {
        text: title,
        infoTip: infoTip,
        alignRight: titleAlignRight
      }), /*#__PURE__*/_react["default"].createElement("div", {
        className: classes.flagValue
      }, /*#__PURE__*/_react["default"].createElement(_Flag.Flag, {
        size: "sm",
        code: value
      }), " ", value));
    default:
      return /*#__PURE__*/_react["default"].createElement("div", {
        "data-testid": testId,
        className: classes.root,
        style: style
      }, /*#__PURE__*/_react["default"].createElement(_SectionHeader.SectionHeader, {
        text: title,
        infoTip: infoTip,
        alignRight: titleAlignRight
      }), /*#__PURE__*/_react["default"].createElement("p", {
        className: classes.value
      }, value));
  }
};
exports.Stat = Stat;